import { resolvePriceProductFormatCode } from './clientType';

const normalized = (value) => String(value ?? '').trim().toLowerCase();
const configuredCode = (format) => normalized(typeof format === 'string' ? format
  : format?.productFormatCode || format?.productFormat?.code || format?.ProductFormat?.code
    || format?.code || format?.value || format?.clientType);

// Existing companies can rename the configured Mayorista format to Pack without
// changing its stable code. Only that explicit configured name enables Pack
// behavior; purchase-unit labels and promotional names are unrelated.
export const isRepeatableProductFormat = (format, formatOptions = []) => {
  const code = configuredCode(format);
  if (code === 'pack') return true;
  if (code !== 'mayorista') return false;
  const metadata = typeof format === 'object' && format !== null ? format : {};
  const option = formatOptions.find((entry) => configuredCode(entry) === code);
  const name = option?.name || option?.label || metadata.productFormatName
    || metadata.productFormat?.name || metadata.ProductFormat?.name || metadata.name || metadata.label;
  return normalized(name) === 'pack';
};

export const packFormatIdentity = (format) => {
  const unit = String(format.metricUnit ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  const weight = Number(format.unitWeightKg);
  return unit && Number.isFinite(weight) && weight > 0
    ? `${unit}:${Math.round((weight + Number.EPSILON) * 1000)}` : null;
};

export const haveConflictingFormatIdentity = (left, right, formatOptions = []) => {
  const code = resolvePriceProductFormatCode(left);
  if (code !== resolvePriceProductFormatCode(right)
    && !(isRepeatableProductFormat(left, formatOptions) && isRepeatableProductFormat(right, formatOptions))) return false;
  return !isRepeatableProductFormat(left, formatOptions) || !isRepeatableProductFormat(right, formatOptions)
    || (packFormatIdentity(left) !== null && packFormatIdentity(left) === packFormatIdentity(right));
};

export const hasChangedFormatIdentity = (format, baseline, formatOptions = []) => !baseline
  || resolvePriceProductFormatCode(format) !== resolvePriceProductFormatCode(baseline)
  || (isRepeatableProductFormat(format, formatOptions)
    && packFormatIdentity(format) !== packFormatIdentity(baseline));

export const packWeightLabel = (format, formatOptions = []) => isRepeatableProductFormat(format, formatOptions)
  && Number.isFinite(Number(format.unitWeightKg)) && Number(format.unitWeightKg) > 0
  ? `${Number(Number(format.unitWeightKg).toFixed(3))} kg` : '';
